<template>
    <div>
      <template v-for="(child,index) in menuData">
        <el-submenu v-if="child.children.length > 0" :index="child.id+'-'+index" :class="$route.path==child.path?'is-active':''">
          <template slot="title">
            <!-- <i :class="child.iconCls?child.iconCls:''"></i> -->
            <span slot="title">{{child.name}}</span>
          </template>
          <menu-tree :menuData="child.children"></menu-tree>
        </el-submenu>

        <el-menu-item v-if="child.menuType < 2 && child.children.length == 0" :index="child.path">
          <!-- <i :class="child.iconCls?child.iconCls:''"></i> -->
          <span slot="title">{{child.name}}</span>
        </el-menu-item>
      </template>
    </div>
</template>

<script>
export default {
  name: 'menuTree',
  props: ['menuData']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/menuTree.vue